/**
 * A thin bridge between the entity page and the MCP tool pipeline.
 *
 * While the entity page is open, it registers its `EntityChatPage` adapter here.
 * The `add_entity_field` tool and the confirm lane use it to prefill edits; only the page's own buttons save.
 * The page removes the adapter on destroy.
 */
import { Injectable } from '@angular/core';
import type { EntityChatPage } from '../../dashboard/entity/zs-entity/chat/entity-chat-session';
import type { EntityConfirmPage } from './actions/entity-confirm';

@Injectable({ providedIn: 'root' })
export class EntityPageBridgeService {
  private adapter: EntityChatPage | null = null;
  private confirmAdapter: EntityConfirmPage | null = null;

  register(page: EntityChatPage, confirm: EntityConfirmPage | null = null): void {
    this.adapter = page;
    this.confirmAdapter = confirm;
  }

  unregister(): void {
    this.adapter = null;
    this.confirmAdapter = null;
  }

  get confirm(): EntityConfirmPage | null {
    return this.confirmAdapter;
  }

  get page(): EntityChatPage | null {
    return this.adapter;
  }
}
